import React from "react"
import { Helmet } from "react-helmet"

import Layout from "../../../components/layout"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"
import Link from "../../../components/Link"

const MariannePage = props => {
  const {
    breadcrumb: { crumbs },
  } = props.pageContext
  var customCrumbLabel = props.location.pathname
    .replace("-", " ")
    .replace(/.*\//g, "")
  return (
    <Layout location={props.location}>
      <Helmet>
        <html className="memberpage" lang="da" />
      </Helmet>
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <Breadcrumb
              crumbs={crumbs}
              crumbSeparator=" / "
              crumbLabel={customCrumbLabel}
            />
          </div>
        </div>
      </div>
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <div className="space-8"></div>

            <div className="grid">
              <div className="member-2col-left">
                <div className="member-inner">
                  <h1>Marianne Grønlund Toft</h1>
                  <h3>Professional</h3>
                  <div
                    class="table-container"
                    role="table"
                    aria-label="Destinations"
                  >
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Date of employment at Emento
                      </div>
                      <div class="flex-row" role="cell">
                        January 2021
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Title
                      </div>
                      <div class="flex-row" role="cell">
                        Business Controller
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Responsibilities
                      </div>
                      <div class="flex-row" role="cell">
                        Accounting
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Educational background
                      </div>
                      <div class="flex-row" role="cell">
                        Bachelor Degree of Accounting, Revision and Finance
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Previous positions/industries
                      </div>
                      <div class="flex-row" role="cell">
                        Business Controller/IT
                      </div>
                    </div>
                  </div>
                  <h3>Personal</h3>
                  <div
                    class="table-container"
                    role="table"
                    aria-label="Destinations"
                  >
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Bucket list no. 1
                      </div>
                      <div class="flex-row" role="cell">
                        To be a good human being
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Favorite music
                      </div>
                      <div class="flex-row" role="cell">
                        Queen, Peter Gabriel, David Bowie, The Weeknd, Coldplay,
                        Bruce Springsteen and U2
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Biggest food or drink consumption
                      </div>
                      <div class="flex-row" role="cell">
                        Seafood, vegetables, cheese. Champagne, water, G&amp;T
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Best TV series
                      </div>
                      <div class="flex-row" role="cell">
                        Crimes, Nature/animal, Søren Ryge and Bonderøven
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Extraordinary skill
                      </div>
                      <div class="flex-row" role="cell">
                        Painting, Flower decorations and writing party songs
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Preferred traveling style
                      </div>
                      <div class="flex-row" role="cell">
                        By plane - and not alone
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        My friends recognizes me for
                      </div>
                      <div class="flex-row" role="cell">
                        Trustworthy and humorous
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        As a kid, I wanted to become
                      </div>
                      <div class="flex-row" role="cell">
                        Farmer or florist
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Social links
                      </div>
                      <div class="flex-row" role="cell">
                        <Link
                          to="https://www.linkedin.com/in/marianne-gr%C3%B8nlund-toft-56085810/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          LinkedIn
                        </Link>
                        <br />
                        <Link
                          to="https://www.facebook.com/profile.php?id=100001504377687"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Facebook
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="member-2col-middle">
                <div className="member-hero-inner">
                  <div className="member-hero-box">
                    <div className="member-hero-image">
                      <img
                        src="/images/portraits/internal/marianne_hero.jpg"
                        alt=""
                      />
                    </div>
                    <h3>Feels like: Peddersen (from Peddersen &amp; Findus)</h3>
                    Strength
                    <div className="full-bar">
                      <div className="bar size-50" />
                    </div>
                    Artistic
                    <div className="full-bar">
                      <div className="bar size-70" />
                    </div>
                    Spontaneous
                    <div className="full-bar">
                      <div className="bar size-70" />
                    </div>
                    Determined
                    <div className="full-bar">
                      <div className="bar size-70" />
                    </div>
                    Polite
                    <div className="full-bar">
                      <div className="bar size-90" />
                    </div>
                    Playful
                    <div className="full-bar">
                      <div className="bar size-90" />
                    </div>
                    Empathy
                    <div className="full-bar">
                      <div className="bar size-90" />
                    </div>
                    Intelligence
                    <div className="full-bar">
                      <div className="bar size-60" />
                    </div>
                    Brave
                    <div className="full-bar">
                      <div className="bar size-70" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="member-2col-right">
                <div className="member-childhood-inner">
                  <div
                    className="member-childhood-image"
                    style={{
                      backgroundImage: `url(/images/portraits/internal/marianne_child.jpg)`,
                    }}
                  >
                    <div className="blur-bg">
                      <img
                        src="/images/portraits/internal/marianne_child.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default MariannePage
